export default __webpack_public_path__ + "static/fs-icon-180x180-bad5125227e9e19039af89c060b1aa7d.png";